<template>
  <div class="datetimepicker">
    <!-- Native Datepicker -->
    <b-form-input
      v-if="supported"
      type="datetime-local"
      :id="id"
      :name="name"
      :readonly="readonly"
      :disabled="disabled"
      v-model="datetime">
    </b-form-input>
    <!-- / Native Datepicker -->

    <!-- Fallback -->
    <b-input-group v-else>
      <!-- Picker -->
      <datetime
        input-class="form-control"
        format="MM/dd/yyyy, hh:mm a"
        type="datetime"
        use12-hour
        value-zone="local"
        placeholder="mm/dd/yyyy, --:-- --"
        auto
        :input-id="id"
        :readonly="readonly"
        :disabled="disabled"
        :phrases="{ok: 'OK', cancel: 'Cancel'}"
        :minute-step="5"
        v-model="datetime">
      </datetime>
      <!-- / Picker -->

      <!-- Clear -->
      <b-input-group-append>
        <b-button
          type="button"
          tabindex="-1"
          :disabled="disabled || readonly"
          @click="datetime = ''">
          <font-awesome-icon
            icon="times">
          </font-awesome-icon>
        </b-button>
      </b-input-group-append>
      <!-- / Clear -->
    </b-input-group>
    <!-- / Fallback -->
  </div>
</template>

<script>
const isDatetimeSupported = () => {
  const $input = document.createElement('input');
  const value = 'a';
  $input.setAttribute('type', 'datetime-local');
  $input.setAttribute('value', value);
  return $input.value !== value;
};

export default {
  name: 'datetimepicker',
  props: [
    'value',
    'id',
    'name',
    'readonly',
    'disabled',
  ],
  data() {
    return {
      supported: isDatetimeSupported(),
      datetime: '',
    };
  },
  watch: {
    datetime(value) {
      let v = value;

      if (value) {
        v = value.slice(0, 19);
      }

      this.$emit('input', v);
    },
    value(value) {
      this.datetime = value;
    },
  },
  created() {
    this.datetime = this.value;
  },
};
</script>

<style lang="scss">
.datetimepicker {
  .vdatetime {
    width: calc(100% - 37px);
  }
  .input-group-append {
    width: 37px;
  }
}
</style>
